"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _color = _interopRequireDefault(require("../choices/color.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var graphics = {
  ghostly: {
    background: _color["default"].surfaceLight50
  },
  workingDesk: {
    background: 'transparent'
  },
  clock: {
    background: _color["default"].cloudyBlue100
  },
  incomingCall: {
    background: _color["default"].white
  }
};
var _default = graphics;
exports["default"] = _default;